import React from 'react';
import PropTypes from 'prop-types';
import css from './HelpResources.scss';
import { HelpDeskInformation } from 'utils/types';
import { isEmptyString } from 'utils/text';
import HelpPhone from './HelpPhone';
import HelpEmail from './HelpEmail';
import HelpWebsite from './HelpWebsite';

/**
 * @param {Object} helpDeskInformation - the help resources to be displayed to users
 * @param {boolean} studentView - if the help resources are being displayed to students
 * @returns {JSX.Element} - Institution Help Resources, including email address, phone number and website
 */
function HelpResources ({ helpDeskInformation, studentView }) {
    const { email, phone, url } = helpDeskInformation;

    const headerText = studentView && !isEmptyString(helpDeskInformation.studentDisplayText)
        ? helpDeskInformation.studentDisplayText
        : "Help Resources";

    if (isEmptyString(phone) && isEmptyString(email) && isEmptyString(url)) return null;
    return (
        <div className={css['help-resource']}>
            <p>{headerText}</p>
            <hr />
            <div className={css['help-card']}>
                <HelpPhone phone={phone} />
                <HelpEmail email={email} />
                <HelpWebsite supportWebsiteDisplayText={helpDeskInformation.supportWebsiteDisplayText}
                             url={url} />
            </div>
        </div>
    );
}

HelpResources.defaultProps = {
    studentView: false
};

HelpResources.propTypes = {
    helpDeskInformation: HelpDeskInformation,
    studentView: PropTypes.bool
}

export default HelpResources;
